import types from './widget-types';

import BarGraphWidget from "./BarGraphWidget";
import DetailsTableWidget from "./DetailsTableWidget";

export default {
    [types.BAR]: BarGraphWidget,
    [types.DETAILS_TABLE]: DetailsTableWidget
}